// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-render-marker {
    width: 25px;
    height: 25px;
    /* background-color: red; */
    margin-bottom: 10px;
    /* Google Maps marker color */
    border-radius: 50% 50% 50% 0;
    position: relative;
    transform: rotate(-45deg);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-render-marker::after {
    content: "";
    width: 21.5px;
    height: 21.5px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 49%;
    left: 49%;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.absolute-render-center {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 48%;
    top: 35%;
    transform: translate(-50%, -50%);
    width: 30px;
    /* Adjust width as needed */
    height: 25px;
    /* Adjust height as needed */
    z-index: 1;
}

.container {
    position: relative;
    width: 35px;
    height: 35px;
    /* margin: 15px; */

}

.outer-circle {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: relative;
    /* Change to relative position */
    background-color: lightgray;
    left: 1%;
    /* Optional: Add background color for clarity */
}

.IPAZAH-content-container {
    /* height: 35.5px !important; */
}

.inner-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.image {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    margin: 0;
    /* Add margin: 0; to remove any default margin */
}


.triangle-style {
    position: absolute;
    bottom: 0px;
    left: 34%;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    z-index: -1;
    /* Ensure triangle is above the circles */
}

.container-mouse-handler {
    position: relative;
    width: 35px;
    height: 35px;
    margin: 2px;
}

.outer-circle-mouse-handler {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: relative;
    /* Change to relative position */
    background-color: lightgray;
    /* Optional: Add background color for clarity */
}

.inner-circle-mouse-handler {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.image-mouse-handler {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    margin: 0;
}

.triangle-style-mouse-handler {
    position: absolute;
    /* bottom: 5px; */
    bottom: -1px;
    left: 10px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: -1;
}

@media screen and (min-width: 1960px) {
    .triangle-style-mouse-handler {
        left: 40%;
    }
}

.camera-icon-border {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    border: 2px solid #589500;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;

}

.juBESy {
    height: 100% !important;
    position: relative;
    width: 100% !important;
}

.image-color-change {
    width: 100%;
    height: 240px;
    opacity: 1;
}


.heading-bar {

    text-align: left;
    font: normal normal bold 30px/39px Roboto;
    letter-spacing: 0px;
    color: #EBEBEB;
    opacity: 1;
}

.button-container {
    width: 330px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: fixed;
    left: 80px;
    bottom: 0px;
    margin: 0px;
    padding: 10px;
    background-color: rgb(30, 30, 30);
}

@media only screen and (max-width: 1280px) {
    .button-container {
        width: 330px;
    }
}

@media only screen and (max-width: 767px) {
    .button-container {
        width: 281px;
    }
}

@media only screen and (max-width: 767px) {
    .button-container {
        width: 281px;
    }
}

@media only screen and (max-width: 747px) {
    .button-container {
        width: 100%;
        position: static;
    }
}


/* Additional media queries for larger screens */
@media only screen and (min-width: 1281px) and (max-width: 1440px) {
    .button-container {
        width: 330px;
        /* Adjust as needed for screens between 1281px and 1440px */
    }
}

/* Media query for even larger screens */
@media only screen and (min-width: 1441px) {
    .button-container {
        width: 330px;
        /* Retain 440px for screens larger than 1440px */
    }
}

.photo-viewer-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(119, 119, 119, 0.4);
    box-sizing: border-box;
    z-index: 1;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.upload-image-icon-style {
    height: 120px;
    width: 120px;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: background-color 0.3s;
}

.upload-image-icon-style:hover {
    filter: blur(1px);
}

.file-drop-target-image {
    box-sizing: border-box;
    height: 120px;
    width: 120px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 10px;
    position: relative;
    background-color: white;
}

.file-drop-target-image:hover {
    background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/component/main-ui/left-toolbar/common/photo-details/photo.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,QAAQ;IACR,+CAA+C;AACnD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,gDAAgD;AACpD;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;AACd;;;AAGA;;IAEI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,WAAW;IACX,WAAW;IACX,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;;AAGA,gDAAgD;AAChD;IACI;QACI,YAAY;QACZ,2DAA2D;IAC/D;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,YAAY;QACZ,gDAAgD;IACpD;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,0CAA0C;IAC1C,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".map-render-marker {\n    width: 25px;\n    height: 25px;\n    /* background-color: red; */\n    margin-bottom: 10px;\n    /* Google Maps marker color */\n    border-radius: 50% 50% 50% 0;\n    position: relative;\n    transform: rotate(-45deg);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.map-render-marker::after {\n    content: \"\";\n    width: 21.5px;\n    height: 21.5px;\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n    top: 49%;\n    left: 49%;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.absolute-render-center {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 48%;\n    top: 35%;\n    transform: translate(-50%, -50%);\n    width: 30px;\n    /* Adjust width as needed */\n    height: 25px;\n    /* Adjust height as needed */\n    z-index: 1;\n}\n\n.container {\n    position: relative;\n    width: 35px;\n    height: 35px;\n    /* margin: 15px; */\n\n}\n\n.outer-circle {\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: relative;\n    /* Change to relative position */\n    background-color: lightgray;\n    left: 1%;\n    /* Optional: Add background color for clarity */\n}\n\n.IPAZAH-content-container {\n    /* height: 35.5px !important; */\n}\n\n.inner-circle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.image {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n    margin: 0;\n    /* Add margin: 0; to remove any default margin */\n}\n\n\n.triangle-style {\n    position: absolute;\n    bottom: 0px;\n    left: 34%;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    z-index: -1;\n    /* Ensure triangle is above the circles */\n}\n\n.container-mouse-handler {\n    position: relative;\n    width: 35px;\n    height: 35px;\n    margin: 2px;\n}\n\n.outer-circle-mouse-handler {\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: relative;\n    /* Change to relative position */\n    background-color: lightgray;\n    /* Optional: Add background color for clarity */\n}\n\n.inner-circle-mouse-handler {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.image-mouse-handler {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n    margin: 0;\n}\n\n.triangle-style-mouse-handler {\n    position: absolute;\n    /* bottom: 5px; */\n    bottom: -1px;\n    left: 10px;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    z-index: -1;\n}\n\n@media screen and (min-width: 1960px) {\n    .triangle-style-mouse-handler {\n        left: 40%;\n    }\n}\n\n.camera-icon-border {\n    width: 30px;\n    height: 30px;\n    border-radius: 5px;\n    border: 2px solid #589500;\n    opacity: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.juBESy {\n    height: 100% !important;\n    position: relative;\n    width: 100% !important;\n}\n\n.image-color-change {\n    width: 100%;\n    height: 240px;\n    opacity: 1;\n}\n\n\n.heading-bar {\n\n    text-align: left;\n    font: normal normal bold 30px/39px Roboto;\n    letter-spacing: 0px;\n    color: #EBEBEB;\n    opacity: 1;\n}\n\n.button-container {\n    width: 330px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    position: fixed;\n    left: 80px;\n    bottom: 0px;\n    margin: 0px;\n    padding: 10px;\n    background-color: rgb(30, 30, 30);\n}\n\n@media only screen and (max-width: 1280px) {\n    .button-container {\n        width: 330px;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .button-container {\n        width: 281px;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .button-container {\n        width: 281px;\n    }\n}\n\n@media only screen and (max-width: 747px) {\n    .button-container {\n        width: 100%;\n        position: static;\n    }\n}\n\n\n/* Additional media queries for larger screens */\n@media only screen and (min-width: 1281px) and (max-width: 1440px) {\n    .button-container {\n        width: 330px;\n        /* Adjust as needed for screens between 1281px and 1440px */\n    }\n}\n\n/* Media query for even larger screens */\n@media only screen and (min-width: 1441px) {\n    .button-container {\n        width: 330px;\n        /* Retain 440px for screens larger than 1440px */\n    }\n}\n\n.photo-viewer-container {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: rgba(119, 119, 119, 0.4);\n    box-sizing: border-box;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    opacity: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.upload-image-icon-style {\n    height: 120px;\n    width: 120px;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transition: background-color 0.3s;\n}\n\n.upload-image-icon-style:hover {\n    filter: blur(1px);\n}\n\n.file-drop-target-image {\n    box-sizing: border-box;\n    height: 120px;\n    width: 120px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-bottom: 10px;\n    position: relative;\n    background-color: white;\n}\n\n.file-drop-target-image:hover {\n    background-color: lightgray;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
